var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeOutFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 2a.75.75 0 010 1.5h-1.52c.012.082.02.165.02.25v4.836c0 .464-.184.91-.513 1.237l-2 2-.032.04a.25.25 0 000 .275l.032.039 2 2c.329.328.513.773.513 1.237V20c0 .174-.027.341-.074.5h1.574a.75.75 0 010 1.5H4.75a.75.75 0 010-1.5h1.574a1.748 1.748 0 01-.074-.5v-4.586c0-.406.141-.798.396-1.11l.117-.127 2-2a.25.25 0 000-.354l-2-2-.117-.128a1.75 1.75 0 01-.396-1.11V3.75c0-.085.008-.168.02-.25H4.75a.75.75 0 010-1.5h14.5z",
    fill: "currentColor"
  })));
}
SvgTimeOutFilled.displayName = 'TimeOutFilled';
export default SvgTimeOutFilled;